import React, { useState, useEffect } from 'react';
import SimpleBar from 'simplebar-react';
import { Card, Accordion } from 'react-bootstrap';
import { ErrorMessage } from './Extras';

// Utilities
import utils from '../_helpers/utils';
import { useRequest } from '../hooks/useRequest';

// Styles
import '../styles/DetailTemplate.scss';

export function DetailTemplate({ apiUrl, children, subresults = false }) {
  const { data, loaded, error } = useRequest(apiUrl, subresults);

  return (
    <SimpleBar style={{ height: 'calc(100vh - 56px)' }} className="detail-component">
      {!loaded && utils.loadingCircle() }
      {error && <ErrorMessage error={error.message} />}
      {loaded && !error && children(data)}
    </SimpleBar>
  );
}

export function DetailHeader({ toggleCompactMode, children }) {
  return (
    <div className="header">
      <button className="button-clear" onClick={toggleCompactMode}>
        <i className="fas fa-arrow-left"></i>
      </button>
      <div className="text-center d-inline">
        {children}
      </div>
    </div>
  )
}

export function DetailAccordion({ ukey, open: propOpen = '0', toggle, collapse }) {
  const [open, setOpen] = useState(propOpen);

  // Update state if propOpen changes
  useEffect(() => {
    setOpen(propOpen);
  }, [propOpen]);

  const handleToggleClick = () => {
    setOpen((prevOpen) => (prevOpen === '0' ? '1' : '0'));
  };

  return (
    <Accordion key={ukey} activeKey={open} className="flipped-accordion">
      <Card className="mission-stage">
        <Accordion.Collapse eventKey="1" className="flipped-collapse stage-collapse">
          {collapse}
        </Accordion.Collapse>
        <Accordion.Toggle
          as={Card.Header}
          variant="link"
          eventKey="1"
          onClick={handleToggleClick}
          className="flipped-header stage-header"
        >
          <h6>{toggle}</h6>
        </Accordion.Toggle>
      </Card>
    </Accordion>
  );
}